<div class="page-not-found d-flex justify-content-start align-items-center">
  <div class="d-flex flex-column justify-content-center pl-5 message">
    <h1 [innerHTML]="'pageNotFound.oops' | translate"></h1>
    <h3 class="mt-2" [innerHTML]="'pageNotFound.noPageFound' | translate"></h3>
    <span class="mt-2" [innerHTML]="'pageNotFound.errorCode' | translate"></span>
    <p class="mt-4" [innerHTML]="'pageNotFound.pleaseContactOptimy' | translate"></p>
    <img class="mt-5" src="assets/images/op-logo.png" alt="logo-image" aria-label="logo">
  </div>
</div>
